/**
 * Admin layout component - now just a wrapper since SidebarLayout handles navigation.
 */
import React from 'react';
import { SidebarLayout } from './SidebarLayout';
import { Footer } from './Footer';
import './AdminLayout.css';

interface AdminLayoutProps {
  children: React.ReactNode;
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  return (
    <SidebarLayout>
      <div className="admin-layout-content">
        {children}
      </div>
      <Footer />
    </SidebarLayout>
  );
};

